import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { materialModules } from '../../../angular-material.module';
import { SharedModule } from '../../../shared/shared.module';
import { CreativeUnitPackageCategoryPickerComponent } from './creative-unit-package-category-picker/creative-unit-package-category-picker.component';


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		ReactiveFormsModule,
		SharedModule,
		...materialModules,
	],
	declarations: [
		CreativeUnitPackageCategoryPickerComponent
	],
	exports: [
		CreativeUnitPackageCategoryPickerComponent
	]
})
export class CreativeUnitPackageCategoryModule { }
